// components/VideoCard.js
import React from "react";

const VideoCard = ({ title, description, link, thumbnail }) => {
  return (
    <div className="video-card group hover:scale-105 transition-transform duration-300 ease-in-out">
      <img src={thumbnail} alt={title} className="rounded-lg w-full h-48 object-cover" />
      <div className="mt-3 text-left">
        <h3 className="text-lg font-semibold text-gray-800 group-hover:text-blue-600 transition">{title}</h3>
        <p className="text-sm text-gray-600 mt-1">{description}</p>
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-2 text-blue-500 hover:text-blue-700 text-sm font-medium"
        >
          ▶ Watch Now
        </a>
      </div>
    </div>
  );
};

export default VideoCard;
